import React, {
  useState, createContext, useContext, useEffect,
} from 'react'
import axios from 'axios'
import localConfig from '../../config/local-config'
import apiConfig from '../../config/api-config'
import { LocalContext } from '../helpers/useLocalContext'
import useIsMounted from '../../hooks/useIsMounted'

export const ArticlesContext = createContext()
export default function ArticlesProvider({
  children,
  pageType,
  uri,
  collection,
  images,
  attributes = {},
}) {
  const isMounted = useIsMounted()
  const { localContext } = useContext(LocalContext)
  const { isBot } = localContext
  const [articles, setArticles] = useState(null)
  const articleRequest = `${apiConfig.apiURL}/v1/lazyload/articles`
  const imagesFormatted = Array.isArray(images) ? images.join(',') : images

  useEffect(() => {
    if (isBot || articles || collection || !isMounted()) return
    const vehicleParams = {
      'vehicle[make]':
        (attributes && attributes.make && attributes.make.make_name) || '',
      'vehicle[model]':
        (attributes && attributes.model && attributes.model.model_name) || '',
      'vehicle[part]':
        (attributes && attributes.part && attributes.part.part_name) || '',
      'vehicle[year]':
        (attributes && attributes.year && attributes.year.year) || '',
      'vehicle[brand]':
        (attributes && attributes.brand && attributes.brand.brand_name) || '',
    }

    axios
      .get(articleRequest, {
        params: {
          domain: localConfig.hostname,
          pageType,
          uri,
          ...vehicleParams,
          images: imagesFormatted,
        },
        headers: {
          apikey: apiConfig.apiKey,
        },
      })
      .then(res => {
        if (!isMounted()) {
          return
        }
        const { data: responseData } = res
        setArticles((responseData && responseData.data) || [])
      })
  }, [
    collection,
    attributes,
    uri,
    articles,
    articleRequest,
    isBot,
    pageType,
    imagesFormatted,
    isMounted,
  ])

  return (
    <ArticlesContext.Provider value={articles}>
      {children}
    </ArticlesContext.Provider>
  )
}
